<template>
    
    <accordion v-for="(value, key, i) in localValue" class="mb-3">
        <template #title>
            <div>
                <span>Modulo <b>{{key}}</b>
                    <template v-if="Object.keys(value).length > 0">
                        ({{Object.keys(value).length}} elementi)
                    </template>
                </span>
            </div>
        </template>
        <div class="p-2 bg-white">
            <table class="table table-striped">
                <thead>
                    <th>
                        Field name (in crucco) 
                        <button class="btn btn-success" @click="showFieldName = !showFieldName">
                            +
                        </button>
                    </th>
                    <th>Tipo campo</th>
                    <th>Escludi</th>
                </thead>
                <tbody>
                    <tr v-if="showFieldName">
                        <td>
                            <form class="d-flex align-items-center" @submit.prevent="addFieldConfigTo(value)">
                                <input type="text" class="form-control" v-model="tempFieldName" ref="tempFieldInput" />
                                <button class="btn btn-primary">
                                    OK
                                </button>
                            </form>
                        </td>
                    </tr>
                    <tr v-for="(config, fieldName, i) in value">
                        <td>
                            <button class="btn btn-danger btn-sm" @click="removeFrom(fieldName as string, value)">-</button> {{fieldName}}
                        </td>
                        <td>
                            <select v-model="config.type">
                                <option v-for="it in dataTypes">{{it}}</option>
                            </select>
                        </td>
                        <td>
                            <toggler v-model="config.exclude"></toggler>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </accordion>
</template>

<script lang="ts">
import { mixins, Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import * as CONST from '@/const';
import WithModel from '@/mixins/withModel';
import { AppConfigClient } from '@/services/Services';

@Options({})
export default class customOnOfficeFields extends mixins(WithModel) {
    
    declare localValue: { [key: string]: { [key: string]: OM.GetFieldsResponse; }; };

    dataTypes = CONST.DataTypes.GetAll();

    showFieldName: boolean = false;
    tempFieldName: string = "";

    addFieldConfigTo(what: { [key: string]: OM.GetFieldsResponse; }){
        if(this.tempFieldName){
            let fieldConfig = new OM.GetFieldsResponse();
            what[this.tempFieldName] = fieldConfig;
        }
        this.showFieldName = false;
        this.tempFieldName = "";
    }

    removeFrom(fieldName: string, value: { [key: string]: OM.GetFieldsResponse; }){
        delete value[fieldName];
    }
    
}
</script>
